/*
  STL SEARCH PANEL — MINKPINK (Edge 2.0.0), 22 Sep 2026. Loaded by sections/stl-search-panel.liquid.

  Resting drawer (Edge's snippets/block-search.liquid):
    - "Popular Searches" rebuilt from the section's blocks (editor-controlled), linking to
      /search?q=<term> with the term as typed (Edge linked the HANDLE — q=wedding-guest).
    - "Product Suggestions" shows two products for the hovered / focused term (first term by
      default) plus "See N results for “term” >", fetched from sections/stl-search-preview
      via the Section Rendering API. Cached per term.
  Typing (Edge's sections/predictive-search.liquid):
    - Edge's suggestions stay. Its products list is replaced by the same two-card preview for
      what is typed — but only once the preview has arrived, so a failed fetch leaves Edge's
      own list in place.
  No Edge file is edited; if this script does not run the drawer is exactly Edge's.
*/
(function () {
  'use strict';

  var dataEl = document.getElementById('stl-search-panel-data');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  // stl.css hides Edge's own "Product Suggestions" cards while this class is on, so the
  // drawer never opens on them and then swaps (Serena, 22 Sep 2026: "a brief flash of the
  // old search preview"). Taken off again if the first preview cannot be fetched, so a
  // failure falls back to Edge's cards rather than to an empty panel.
  document.documentElement.classList.add('stl-search');

  var SEARCH_URL = (window.routes && window.routes.search_url) || '/search';
  // Predictive search endpoint: quicker than a full /search render (no result count needed).
  var SUGGEST_URL = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var cache = {};

  function searchHref(term) {
    return SEARCH_URL + '?q=' + encodeURIComponent(term).replace(/%20/g, '+') + '&options%5Bprefix%5D=last';
  }

  function fetchPreview(term) {
    var key = term.trim().toLowerCase();
    if (!key) return Promise.resolve(null);
    if (!cache[key]) {
      cache[key] = fetch(SUGGEST_URL + '?q=' + encodeURIComponent(term) + '&resources%5Btype%5D=product&resources%5Blimit%5D=2&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=stl-search-preview')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector('.stl-search-preview');
        })
        .catch(function () { delete cache[key]; return null; });
    }
    return cache[key];
  }

  /* ---------- Resting state ---------- */
  function drawer() { return document.getElementById('drawer-search'); }

  function setHeading(block, text) {
    var p = block && block.querySelector(':scope > p');
    if (p && text) p.textContent = text;
  }

  var activeTerm = null;
  function showRestingPreview(term) {
    var d = drawer();
    var rec = d && d.querySelector('.predictive-search_recommend');
    if (!rec || !term) return;
    activeTerm = term;
    fetchPreview(term).then(function (preview) {
      if (!preview) {
        if (!rec.querySelector('.stl-search-preview')) document.documentElement.classList.remove('stl-search');
        return;
      }
      if (activeTerm !== term) return;
      var old = rec.querySelector(':scope > ul, :scope > .stl-search-preview');
      var clone = preview.cloneNode(true);
      if (old) old.replaceWith(clone); else rec.appendChild(clone);
      d.querySelectorAll('.stl-term').forEach(function (a) {
        a.classList.toggle('is-active', a.dataset.term === term);
      });
    });
  }

  function buildResting() {
    var d = drawer();
    if (!d) return false;
    var trend = d.querySelector('.predictive-search_key-trend');
    var rec = d.querySelector('.predictive-search_recommend');
    if (!trend) return false;
    if (trend.dataset.stlBuilt) return true;
    setHeading(trend, data.popularHeading);
    setHeading(rec, data.suggestionsHeading);
    var ul = trend.querySelector('ul');
    if (ul && data.terms && data.terms.length) {
      ul.innerHTML = '';
      data.terms.forEach(function (term) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'stl-term inline-block no-underline';
        a.href = searchHref(term);
        a.textContent = term;
        a.dataset.term = term;
        a.addEventListener('mouseenter', function () { showRestingPreview(term); });
        a.addEventListener('focus', function () { showRestingPreview(term); });
        li.appendChild(a);
        ul.appendChild(li);
      });
    }
    trend.dataset.stlBuilt = '1';
    return true;
  }

  // Build the drawer and fetch the first term's preview as soon as the page has loaded, so
  // the panel is already complete when it opens. The request is one small section render
  // (~2 products), made once per page. Opening the drawer first still works: the click
  // handler starts the same (cached) fetch.
  function prime() {
    if (!buildResting()) return;
    if (!activeTerm && data.terms && data.terms[0]) showRestingPreview(data.terms[0]);
  }

  // On first open, fetch every term's preview and warm its images, so hovering a term swaps
  // to cards that are already downloaded (no blank frame, no fade-in).
  var warmed = false;
  function warmAll() {
    if (warmed || !data.terms) return;
    warmed = true;
    data.terms.forEach(function (term) {
      fetchPreview(term).then(function (preview) {
        if (!preview) return;
        preview.querySelectorAll('img').forEach(function (img) {
          var src = img.currentSrc || img.getAttribute('src');
          if (src) { var i = new Image(); i.src = src; }
        });
      });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('drawer-button[data-target="drawer-search"], [data-target="drawer-search"]')) {
      setTimeout(function () { prime(); warmAll(); }, 0);
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildResting);
  else buildResting();
  if (document.readyState === 'complete') prime();
  else window.addEventListener('load', prime);

  /* ---------- Typing state ---------- */
  var typedTimer = null;
  var typedFor = null;

  function currentQuery() {
    var d = drawer();
    var input = d && d.querySelector('input[type="search"], input[name="q"]');
    return input ? input.value.trim() : '';
  }

  function applyTyped() {
    var d = drawer();
    var results = d && d.querySelector('#predictive-search-results');
    var q = currentQuery();
    if (!results || !q) return;
    if (results.dataset.stlFor === q && results.querySelector('.stl-search-preview')) return;
    typedFor = q;
    fetchPreview(q).then(function (preview) {
      var now = d.querySelector('#predictive-search-results');
      if (!now || typedFor !== q || currentQuery() !== q) return;
      // stl.css hides Edge's products list from the start; if our preview failed, show it.
      if (!preview) { now.classList.add('stl-no-preview'); return; }
      var list = now.querySelector('#predictive-search-results-products-list');
      var anchor = list ? list.closest('.border-t') || list.parentElement : null;
      var old = now.querySelector('.stl-typed-preview');
      if (old) old.remove();
      var wrap = document.createElement('div');
      wrap.className = 'stl-typed-preview';
      // Same heading as the resting panel's "Product Suggestions", as live does.
      var h = document.createElement('p');
      h.className = 'stl-search-heading-sm';
      h.textContent = data.suggestionsHeading || 'Product Suggestions';
      wrap.appendChild(h);
      wrap.appendChild(preview.cloneNode(true));
      if (anchor) {
        anchor.insertAdjacentElement('afterend', wrap);
      } else {
        var groups = now.querySelector('#predictive-search-results-groups-wrapper') || now;
        groups.appendChild(wrap);
      }
      now.dataset.stlFor = q;
      now.classList.add('stl-has-preview');
    });
  }

  function watchTyped() {
    var d = drawer();
    var host = d && d.querySelector('[data-predictive-search]');
    if (!host || host.dataset.stlWatch) return;
    host.dataset.stlWatch = '1';
    new MutationObserver(function () {
      var results = host.querySelector('#predictive-search-results');
      if (!results || results.classList.contains('stl-has-preview')) return;
      clearTimeout(typedTimer);
      typedTimer = setTimeout(applyTyped, 0);
    }).observe(host, { childList: true, subtree: true });
    // Start the preview fetch as the visitor types, in parallel with Edge's own request, so it
    // is usually cached by the time Edge renders its results.
    var input = d.querySelector('input[type="search"], input[name="q"]');
    var prefetchTimer = null;
    if (input) input.addEventListener('input', function () {
      clearTimeout(prefetchTimer);
      prefetchTimer = setTimeout(function () { var q = currentQuery(); if (q) fetchPreview(q); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchTyped);
  else watchTyped();
})();
